/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderUserContext } from '../user';
import { ToastrService } from 'ngx-toastr';
import { forEach } from 'lodash';
import { Subject, Observable } from 'rxjs';
import { take } from 'rxjs/internal/operators';
import { DialogService } from '@gh/core-ui';
import { smsViewDialogRoute } from '../communications';
import { WebSocketService } from './web-socket.service';

@Injectable()
export class SmsService {
  smsCount$: Observable<any>;
  smsCount: number;
  private smsCountSubject = new Subject<number>();

  constructor(public userContext: BuilderUserContext,
              private toastr: ToastrService,
              private webSocket: WebSocketService,
              private dialogService: DialogService,
             ) {
    this.smsCount$ = this.smsCountSubject.asObservable();
  }

  connect(): void {
    this.webSocket.on(`/ws/topic/${this.userContext?.office?.id}/${this.userContext.data.id}/messages`, (res: any) => {
      const messages = JSON.parse(res.body);
      forEach(messages, ((item: any) => {
        this.toastr.show(item.message, `SMS From: ${item.contactName ? item.contactName : item.cellPhone}`)
          .onTap
          .pipe(take(1))
          .subscribe(() => this.openViewDialog(item));
      }));
    });
    this.webSocket.on(`/ws/topic/${this.userContext?.office?.id}/${this.userContext.data.id}/messages/count`, (res: any) => {
      this.smsCount = JSON.parse(res.body)['newMessagesCount'];
      this.updateCount();
    });
  }

  updateCount(): void {
    this.smsCountSubject.next(this.smsCount);
  }

  sendName(): void {
    this.webSocket.send('/ws/message/count', {'officeId': this.userContext.office ? this.userContext.office.id : ''});
  }

  openViewDialog(sms: any): void {
    this.dialogService.openWithInput(smsViewDialogRoute, <any>{
      sms: {
        cellPhone: sms.cellPhone,
        message: sms.message,
        contactName: sms.contactName,
        contactId: sms.contactId,
        communicationId: sms.communicationId,
        isMarkedAsRead: false,
        isUnsubscribed: sms.unsubscribed,
      },
    }).afterClosed();
  }
}
